import React from 'react';
import PropTypes from 'prop-types';

const SimpleGrid = props => (
  <section className="dtp-datagrid">
    <div className="dtp-datagrid-data">
      <div className="dtp-datagrid-items-box" >
        {props.children}
      </div>
    </div>
  </section>
);

SimpleGrid.propTypes = {
  title: PropTypes.string,
  icon: PropTypes.string,
  children: PropTypes.element,
}.isRequired;

export default SimpleGrid;



// WEBPACK FOOTER //
// ./src/components/ComponentesBasicos/SimpleGrid.jsx